export const SUBSCRIPTION_FEATURE_KEYS = [
  "subscription.modal.feature.masterkat",
  "subscription.modal.feature.katarzaLive",
  "subscription.modal.feature.stories",
  "subscription.modal.feature.educatorContact",
  "subscription.modal.feature.newContent",
  "subscription.modal.feature.cancelAnytime",
];

export const SUBSCRIPTION_CANCEL_REASON_KEYS = [
  "tooExpensive",
  "notEnoughTime",
  "notRelevant",
  "technicalIssues",
  "pause",
  "other",
];
